import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, FormControl, InputGroup, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Store } from "../Store";

import useAxios from "../hooks/useAxios";
import useTableTypes from "../hooks/useTableTypes";
import useUsers from "../hooks/useUsers";
import { getError } from "../utils";
import TableUsersModal from "./TableUsersModal";

export default function TableDescription(props) {
  const {
    showEnterDescription,
    setShowEnterDescription,
    tableNum,
    onBusinessUser,
    tableType,
  } = props;
  const descriptionRef = useRef(null);
  const [description, setDescription] = useState(props.description || "");
  const [showTableUsersModal, setShowTableUsersModal] = useState(false);
  const [alertTimePeriod, setAlertTimePeriod] = useState(props.alertTimePeriod);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedTableType, setSelectedTableType] = useState();
  const axios = useAxios();
  useUsers();
  useTableTypes();

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { carts, users = [], tableTypes = [] } = state;

  useEffect(() => {
    setDescription(carts[tableNum - 1]?.description || "");
    setAlertTimePeriod(carts[tableNum - 1]?.alertTimePeriod);
  }, [tableNum, carts]);

  useEffect(() => {
    if (onBusinessUser && users) {
      setSelectedUser(users.find((u) => u._id === onBusinessUser));
    } else {
      setSelectedUser(null);
    }
  }, [onBusinessUser, users]);

  const handleSelect = (user) => {
    setDescription(user.name);
  };

  useEffect(() => {
    if (tableType && tableTypes) {
      setSelectedTableType(tableTypes.find((u) => u._id === tableType));
    } else {
      setSelectedTableType(null);
    }
  }, [tableType, tableTypes]);

  const handleDescriptionChange = async () => {
    try {
      const { data } = carts[tableNum - 1].tableCode
        ? { data: carts[tableNum - 1] }
        : await axios.get(`/api/customer?tableNum=${tableNum}`);

      const payload = {
        description,
        onBusinessUser: selectedUser?._id,
        tableType: selectedTableType?._id || "",
      };

      if (alertTimePeriod) {
        payload.alertTimePeriod = alertTimePeriod;
      }

      await axios.put(`/api/customer/orders/${data.tableCode}`, payload);

      setShowEnterDescription(false);
      toast.success("Masa bilgileri güncellendi");
    } catch (err) {
      toast.error(getError(err));
    }
  };

  return (
    <>
      <Modal
        centered
        size="sm"
        show={showEnterDescription}
        onHide={() => {
          setShowEnterDescription(false);
        }}
        onShow={() => descriptionRef.current?.focus()}
      >
        <Modal.Header closeButton>
          <Modal.Title>{tableNum} Nolu Masa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mt-3">
              <Form.Label>Masa Türü</Form.Label>
              <Form.Select
                value={
                  selectedTableType ? JSON.stringify(selectedTableType) : ""
                }
                onChange={(e) => {
                  const value = JSON.parse(e.target.value);
                  setSelectedTableType(value);
                }}
                aria-label="Seç"
              >
                <option value={JSON.stringify("")}>Seç</option>
                {tableTypes
                  .filter((t) => t.status)
                  .map((u) => (
                    <option key={u._id} value={JSON.stringify(u)}>
                      {u.name}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Masa Adı</Form.Label>
              <InputGroup>
                <FormControl
                  type="text"
                  value={description}
                  ref={descriptionRef}
                  onChange={(e) => {
                    setDescription(e.target.value || "");
                  }}
                  placeholder="İsim gir."
                />
                <Button
                  variant="success"
                  onClick={() => setShowTableUsersModal(true)}
                >
                  Seç
                </Button>
              </InputGroup>
            </Form.Group>

            {/* New Dropdown for Alert Time Period */}
            <Form.Group className="mt-3">
              <Form.Label>Sipariş Hatırlatma Süresi Seçimi</Form.Label>
              <Form.Select
                value={alertTimePeriod}
                onChange={(e) => setAlertTimePeriod(e.target.value)}
                aria-label="Hatırlatma Süresi Seçin"
              >
                <option value="">Hatırlatma için süre tutma</option>
                <option value="30">30 dk süre tut</option>
                <option value="45">45 dk süre tut</option>
                <option value="60">1 saat süre tut</option>
                <option value="90">90 dk süre tut</option>
                <option value="120">2 saat süre tut</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Masadan Sorumlu Olacak Çalışan</Form.Label>
              <Form.Select
                value={selectedUser ? JSON.stringify(selectedUser) : ""}
                onChange={(e) => {
                  const value = JSON.parse(e.target.value);
                  setSelectedUser(value);
                }}
                aria-label="Seç"
              >
                <option value="">Seç</option>
                {users.map((u) => (
                  <option key={u._id} value={JSON.stringify(u)}>
                    {u.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="border-primary text-primary"
            variant="light"
            onClick={handleDescriptionChange}
          >
            Kaydet
          </Button>
          <Button
            className="border-danger text-danger"
            variant="light"
            onClick={() => {
              setShowEnterDescription(false);
            }}
          >
            İptal
          </Button>
        </Modal.Footer>
      </Modal>

      <TableUsersModal
        showTableUsersModal={showTableUsersModal}
        setShowTableUsersModal={setShowTableUsersModal}
        handleSelect={handleSelect}
      />
    </>
  );
}
